import apiCall from '@/utils/api'

const state = {
	suppliers: [],
	allSuppliers: [],
    supplierPagination: {
		search: ' ',
		current_page: 1,
		per_page: 0,
	    total: 0,
	    visible: 10
	},
    supplierLoader: false
};

const getters = {
	suppliers: (state) => state.suppliers,
	allSuppliers: (state) => state.allSuppliers,
    supplierLoader: (state) => state.supplierLoader,
    supplierPagination: (state) => state.supplierPagination
}

const actions = {
	async fetchAllSuppliers({commit}, page) {
		const response = await apiCall({url: `/api/supplier?type=all`, method: 'GET' });
		commit('setAllSuppliers', response)
        commit('stopLoader', response)
	},
    async fetchSuppliers({commit}, page) {
		const response = await apiCall({url: `/api/supplier?page=${page}`, method: 'GET' });
		commit('setSuppliers', response)
        commit('stopLoader', response)
	},
    async filterSuppliers({commit, state},resp){
		commit('setSuppliers', resp)
	},
	async startSupplierLoader({commit, state},resp){
		commit('startLoader', resp)
	},
	async stopSupplierLoader({commit, state},resp){
		commit('stopLoader', resp)
	},
};

const mutations = {
	setSuppliers: (state, suppliers) => {
		state.suppliers = suppliers.data
		state.supplierPagination.current_page = suppliers.current_page
		state.supplierPagination.total = suppliers.total
		state.supplierPagination.per_page = suppliers.per_page
	},
	setAllSuppliers: (state, suppliers) => {
		state.allSuppliers = suppliers
	},
    startLoader: (state) => state.supplierLoader = true,
	stopLoader: (state) => state.supplierLoader = false,
};

export default {
	state,
	getters,
	actions,
	mutations
}
